import { useContext } from "react";
import { AuthStatusContext, UseAuthStatusPayload } from "./context";

export const useAuthStatus = (): UseAuthStatusPayload => {
	const context = useContext(AuthStatusContext);

	if (!context) {
		throw new Error("useAuthStatus must be used within a AuthStatusProvider");
	}

	return context;
};
